import axios from 'axios';

/**
 * API utility for making requests to the server
 *
 * This utility handles common API operations and provides a consistent interface
 * for making requests to the server.
 */
const api = {
  /**
   * Get the JWT token from localStorage
   * @returns {string|null} - The JWT token or null if not found
   */
  getAuthHeader: () => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  /**
   * Make a GET request
   * @param {string} endpoint - The API endpoint to request
   * @param {Object} params - Query parameters
   * @returns {Promise} - The axios response
   */
  get: (endpoint, params = {}) => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}/wp-json/beaver_next_wordpress/v1${endpoint}`,
      {
        params,
        headers: api.getAuthHeader(),
      },
    );
  },

  /**
   * Make a POST request
   * @param {string} endpoint - The API endpoint to request
   * @param {Object} data - The data to send
   * @param {Object} options - Additional axios options
   * @returns {Promise} - The axios response
   */
  post: (endpoint, data = {}, options = {}) => {
    return axios.post(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}/wp-json/beaver_next_wordpress/v1${endpoint}`,
      data,
      {
        ...options,
        headers: {
          ...options.headers,
          ...api.getAuthHeader(),
        },
      },
    );
  },

  /**
   * Make a PUT request
   * @param {string} endpoint - The API endpoint to request
   * @param {Object} data - The data to send
   * @returns {Promise} - The axios response
   */
  put: (endpoint, data = {}) => {
    return axios.put(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}/wp-json/beaver_next_wordpress/v1${endpoint}`,
      data,
      {
        headers: api.getAuthHeader(),
      },
    );
  },

  /**
   * Make a DELETE request
   * @param {string} endpoint - The API endpoint to request
   * @param {Object} data - The data to send
   * @returns {Promise} - The axios response
   */
  delete: (endpoint, data = {}) => {
    return axios.delete(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}/wp-json/beaver_next_wordpress/v1${endpoint}`,
      {
        data,
        headers: api.getAuthHeader(),
      },
    );
  },
};

export default api;